<template>
    <div class="component-box">
        <van-tabbar
                v-model="tempActive"
                route
                active-color="#00BFFF"
                inactive-color="#000000"
                :safe-area-inset-bottom="true"
        style="height:50px;line-height:50px;" >
            <van-tabbar-item to="/" icon="home-o" class="my-tabbar">
                <span>主页</span>
               <img
                       slot="icon"
                       slot-scope="props"
                       :src="active === 1 ? icon.home.activeImg : icon.home.noActiveImg"
               >
            </van-tabbar-item>
            <van-tabbar-item to="/goodsCategory" icon="apps-o" class="my-tabbar">
                <span>商品分类</span>
               <img
                       slot="icon"
                       slot-scope="props"
                       :src="active === 2 ? icon.category.activeImg : icon.category.noActiveImg"
               >
            </van-tabbar-item>
<!--         nearbyShop   -->
            <van-tabbar-item to="/nearbyShop" icon="location-o" class="my-tabbar">
                <span>附近商家</span>
               <img style="width:30px;height:30px;"
                       slot="icon"
                       slot-scope="props"
                       :src="active === 3 ? icon.nearby.activeImg : icon.nearby.noActiveImg"
               >
            </van-tabbar-item>
            <van-tabbar-item to="/cart" icon="shopping-cart-o" class="my-tabbar">
                <span>商品车</span>
               <img
                       slot="icon"
                       slot-scope="props"
                       :src="active === 4 ? icon.cart.activeImg : icon.cart.noActiveImg"
               >
            </van-tabbar-item>
            <van-tabbar-item to="/userInfo" icon="contact" class="my-tabbar">
                <span>我的</span>
               <img
                       slot="icon"
                       slot-scope="props"
                       :src="active === 5 ? icon.my.activeImg : icon.my.noActiveImg"
               >
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    export default {
        name: "TheFooterBar",
        props:{
            active:{
                type: Number,
                default: 1,
            }
        },

        data(){
            return{
                tempActive:1,
                icon:{
                    home:{
                        activeImg:require('../../assets/img/icon/footerIcon/tab-home-current-blue.png'),
                        noActiveImg:require('../../assets/img/icon/footerIcon/tab-home.png')
                    },
                    category:{
                        activeImg:require('../../assets/img/icon/footerIcon/tab-category-current-blue.png'),
                        noActiveImg:require('../../assets/img/icon/footerIcon/tab-category.png')
                    },
                    nearby:{
                        activeImg:require('../../assets/img/icon/footerIcon/tab-nearby-current-blue.png'),
                        noActiveImg:require('../../assets/img/icon/footerIcon/tab-nearby.png')
                    },
                    cart:{
                        activeImg:require('../../assets/img/icon/footerIcon/tab-cart-current-blue.png'),
                        noActiveImg:require('../../assets/img/icon/footerIcon/tab-cart.png')
                    },
                    my:{
                        activeImg:require('../../assets/img/icon/footerIcon/tab-my-current-blue.png'),
                        noActiveImg:require('../../assets/img/icon/footerIcon/tab-my.png')
                    }
                }
            }
        },
        mounted() {
            this.tempActive = this.active;
        },
    }
</script>

<style>
    .van-tabbar-item__text{
        font-size: 12px;
    }
    .my-tabbar img{
        width: 22px !important;
        height: 22px !important;
    }
</style>